import { createAsyncThunk } from '@reduxjs/toolkit';
import doFetch from 'utils/api/doFetch';

import type {
  DeviceAssignmentsRequestBody,
  DeviceMemberAccessResponseType,
  MemberAssignmentsRequestBody,
  OrganizationId,
} from 'redux-store/slices/organizationOverview/types';

const deleteDeviceMemberAccessThunk = createAsyncThunk(
  'organizationOverview/deleteDeviceMemberAccessThunk',
  async ({
    organizationId,
    data,
  }: {
    organizationId: OrganizationId;
    data: DeviceAssignmentsRequestBody | MemberAssignmentsRequestBody;
  }): Promise<DeviceMemberAccessResponseType> => {
    try {
      const apiPointName = 'deleteDeviceMemberAccess';

      return await doFetch<typeof apiPointName>({
        apiPointName,
        body: data,
        urlParams: { organizationId },
      });
    } catch (e) {
      return Promise.reject(e);
    }
  },
);

export default deleteDeviceMemberAccessThunk;
